import { ReactNode } from "react";
import { Header } from "@/components/ui/header";

/* Props */
interface LayoutProps {
  children: ReactNode;
}

/*
 * RootLayout component
 * This layout wraps most of the pages in the application
 */
export const RootLayout = ({ children }: LayoutProps) => {
  /* Render */
  return (
    <div className="grow flex flex-col gap-4 p-4 max-h-screen">
      <Header />
      {children}
    </div>
  );
};
